<template>
	<div>
		<app-twofa :call_from="'Ip-White-List'" v-if="parseInt(get_user.profile.gAuthenticatorEnabled) == 0 && otp_allow"></app-twofa>
		<div class="mid_scroll_content" v-show="parseInt(get_user.profile.gAuthenticatorEnabled) == 1 || !otp_allow">
			<section class="depoist_fund max-1440 pb-5">
				<div class="row justify-content-center">
					<div class="col-10">
						<div class="d-flex align-items-center">
							<div class="info_icon mr-4">
								<feather type="info"></feather>
							</div>
							<p class="mb-0">By adding one or more IP Address to the list, you will be allowed to place orders or withdraw funds from those mentioned address. If you wish to add or remove an IP Address, you need to have the Two Factor Authentication (2FA) enabled as well as providing the authenticator code before submitting for changes.</p>
						</div>

					</div>
					<div class="col-4">

					</div>
				</div>
			</section>
			<!-- Create new Ip -->
			<create-ip></create-ip>
			<!-- Ip List -->
			<ip-list></ip-list>
		</div>
	</div>
</template>

<script>

import create from './create'
import list from './list'
import TwoFa from '../security/security'
export default {
    name: 'ipwishlistaddress',
    data() {
        return {
        	otp_allow: false
        }
    },
	components:{
		createIp : create,
		ipList : list,
		appTwofa : TwoFa
	},
	
	created(){
		this.pageName('Add New IP Address')
	}
}
</script>



// WEBPACK FOOTER //
// src/components/website/ip-whiteList/ip-whiteList.vue